export default "__VITE_ASSET__mQOqJKr___"